import { ActionTypes, TSpinner, TAlert, TActionTypes } from './types'

/**
 * @function spinnerChange
 * @param payload
 */
function spinnerChange(payload: TSpinner): TActionTypes {
  return {
    type: ActionTypes.CHANGE_SPINNER,
    payload,
  }
}

/**
 * @function alertChange
 * @param payload
 */
function alertChange(payload: TAlert): TActionTypes {
  return {
    type: ActionTypes.CHANGE_ALERT,
    payload,
  }
}

export default {
  spinnerChange,
  alertChange,
}
